module.exports = __webpack_public_path__ + "static/program-uni621574-0e19bd8540c32d7cdd02822a75fcf5d4.png";